import { Flex } from '@shared/components';

import { useLongFormTemplateData } from '../../hooks';

import QuestionnaireReportLongFormSection from './questionnaire-report-long-form-section';

export default function QuestionnaireReportLongFormTemplate() {
  const { sections, loading } = useLongFormTemplateData();

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      {sections.map((section) => (
        <QuestionnaireReportLongFormSection key={section.key} section={section} loading={loading} />
      ))}
    </Flex>
  );
}
